export default {
    touchStartThreshold: 6,
    chosenClass: 'active-row-sort',
    dragClass: 'active-row-drag',
    animation: 0,
    handle: '.drag-handle',
};
